import React, { useEffect, useState } from 'react'
import Phonecall from "../../Images/phoencalimage.png"
import Address from "../../Images/adressimage.png"
import Emailimage from "../../Images/emailimage.png"
import HomeNavbar from './HomeNavbar'
import Footer from './Footer'
import axios from "../../axios";
import { Link, useNavigate } from "react-router-dom";
import bgImage from "../../Images/Section (2).png";
import Correct from "../../Images/Vector.png";
import Info from "../../Images/ph_info-duotone.png";
import { FaArrowRightLong } from 'react-icons/fa6'
import CourseCard from '../Dashboard/userPanal/Plans/CourseCard'
function PlanHomePage() {

    const [data, setData] = useState([]);
    useEffect(() => {
      async function fetchData() {
        axios.get("getAllCourses").then((response) => {
          if (response?.data) {
            setData(response?.data?.result);
            localStorage.setItem("plans", JSON.stringify(response?.data?.result));
          }
        });
      }
      fetchData();
    }, []);
  
    console.log(data);
  return (
   <>
   <HomeNavbar />
   <div
            id="plans"
            style={{
              backgroundImage: `url('${bgImage}')`,
              backgroundSize: "cover",
              marginTop: "60px",
              //  backgroundRepeat: 'no-repeat',
              //  backgroundPosition: 'center'
            }}
            className="bg-bgWhite w-full py-4 text-center   lg:px-8 font-poppins"
          >
            <div className=" flex items-center justify-center mb-2">
              <p
                style={{ backgroundColor: "#F5A623" }}
                className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
              >
                Top Class Courses
              </p>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2 mt-1 animate-fade-in">
              Explore Our World's{" "}
              <span className="text-secondary">Best Courses </span>
            </h2>
            {/* <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto px-2">
              Unlock your dream government job with our expert-led courses!
              Explore our comprehensive and interactive learning programs,
              designed to help you crack the toughest government exams with
              ease. From UPSC Civil Services to SSC CGL, Banking, and Defence
              exams, our courses cover it all.
            </p> */}


<div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-8 px-4 pt-2">
  {data?.map((plan, index) => (
    <CourseCard
      key={plan._id}
      plan={plan}
      index={index}
    />
  ))}
</div>
         
{/*   

            <div className="mt-6">
              <Link to={"/"}>
                <div className="w-44 m-auto flex py-2.5 justify-center items-center gap-4 rounded-full bg-secondary text-white shadow-[6px_6px_#F5A623] transition duration-300">
                  <button>See All Courses</button>
                  <FaArrowRightLong />
                </div>
              </Link>
            </div> */}
          </div>
        <Footer/>
   </>
  )
}

export default PlanHomePage
